export default __webpack_public_path__ + "static/media/copy.1b8bc9fe.png";